import { Routes } from "@angular/router";
import { PageNotFoundComponent } from "./use-cases/shared/page-not-found/page-not-found.component";
import { TransactionsOverviewComponent } from "./use-cases/transaction/transactions-overview/transactions-overview.component";
import { loginAuthGuard } from "./use-cases/shared/guards/auth-guard-with-redirect";

export const routes: Routes = [
    {
        path: "transaction/:mandatorId/overview",
        component: TransactionsOverviewComponent,
        canActivate: [loginAuthGuard]
    },
    {
        path: "",
        loadChildren: () => import("./use-cases/payment/payment.routes").then((m) => m.PAYMENT_ROUTES)
    },
    { path: "**", component: PageNotFoundComponent }
] as Routes;
